import React, { Component } from 'react';
import Search from '../Home/Search';

export class AdvisoryBoard extends Component {
    displayName = AdvisoryBoard.name

    render() {
        return (
            <div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-9">
                            <p className="TitlePadding Title">Our ethics statement</p>

                            <a className="TitlePadding" href="http://www.law.cam.ac.uk/people/squire-law-library/l-m-dingle/104" target="_blank" style={{ fontSize: '18px', color: '#007AC3', textDecoration: 'Underline' }}
                            >Lesley Dingle - Foreign & International Law Librarian</a>
                            <br></br>
                            <p className="TitlePadding BookBody">

                                Lesley Dingle is the Foreign & International Law Librarian at the Squire Law Library University of Cambridge,
United Kingdom. She has been working in this role since 1997. She is responsible inter alia for electronic resource
management of FCIL materials. She also teaches courses to undergraduate and postgraduates in the Law Faculty
on sourcing electronic and print content. This is an integral part of the Faculty teaching curriculum. In 2005 Lesley
founded the Eminent Scholars Archive, a unique online resource which documents the careers and works of legal
scholars with strong associations to Cambridge University. It includes oral history and other archival material
related to individual scholars. Extra mural activities have included various consultancies, as well as chair and
membership of several panels, including publishing companies. She is a Senior Member of Wolfson College.
                            </p>
                            <a className="TitlePadding" href="https://www.law.berkeley.edu/php-programs/faculty/facultyProfile.php?facID=4361" target="_blank" style={{ fontSize: '18px', color: '#007AC3', textDecoration: 'Underline' }}>
                                Marci Hoffman - Associate Director, Law Library</a>
                            <br></br>
                            <p className="TitlePadding BookBody">Marci Hoffman works at the University of California, Berkeley School of Law, United States. As the Associate
Director, she is responsible for selection and collection development at the Law Library, including both print and
electronic resources. Her specific area of expertise is international, foreign and comparative law research. As such,
Marci teaches an international and foreign legal research seminar in the law school curriculum. She has written
extensively on international and foreign legal research and resources and is the co-author of International and
Foreign Legal Research: A Coursebook (2d ed. 2012). Marci is the General Editor of the Index to Foreign Legal
Periodicals (AALL) and the Foreign Law Guide (Brill).
                            </p>
                            <a href="http://law.fordham.edu/adjunct/alisonshea.htm" target="_blank" className="TitlePadding" style={{ fontSize: '18px', color: '#007AC3', textDecoration: 'Underline' }}>
                                Alison Shea - Reference Librarian/Foreign & International Specialist</a>
                            <br></br>
                            <p className="TitlePadding BookBody">Alison Shea is Reference Librarian/Foreign & International Specialist at Fordham University School of Law, United
States. She received a BA from Boston University, and a JD and MSLS from The Catholic University of America. Her
particular interest is in foreign, international, and comparative law, and teaches a number of sections of both
basic and advanced legal research courses on a variety of topics, including US legal research for LLMs and foreign
and international research. Alison has authored a number of articles for a variety of publications, and was a coeditor of Sources of State Practice in International Law (2014). She is an active member of the American
Association of Law Libraries, the British and Irish Association of Law Librarians, and the International Association
of Law Libraries
                            </p>
                            <a href="http://www.eur.nl/ub/en/contact/people_to_contact/winter/" target="_blank" className="TitlePadding" style={{ fontSize: '18px', color: '#007AC3', textDecoration: 'Underline' }}>René Winter - Liaison Law Librarian
                                </a>
                            <br></br>
                            <p className="TitlePadding BookBody">Rene Winter works as Liaison Librarian Law at the Erasmus University Rotterdam, the Netherlands. He is
responsible for academic information provision on behalf of the Faculty of Law.
Course specific services consist of providing an efficient way to access relevant literature and sources within the
academic field of law. This involves optimizing and expanding the digital & print collection of the University
Library and acquisitions.


                                <br></br> Additional services consist of consultation, support and training, focused on conducting a literature review,
making effective use of databases, offering academic information through online portals, digitally searching,
finding, selecting, validating and applying academic data.
                            </p>
                        </div>
                    </div>

                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer Section/AdvisoryBoard.jsx